import EquipmentRowAvatar from './EquipmentRowAvatar';

const equipmentAxis = {
  key: 'equipment',
  shiftField: 'equipment',
  headerTitle: 'Equipment',
  unassignedLabel: 'Unassigned',
  RowAvatar: EquipmentRowAvatar,
  getAssignment: (row) => ({ equipment: row ? [row.id] : [] }),
  getReassignArgs: (previousId, newId) => ({
    previousEquipmentId: previousId,
    newEquipmentId: newId,
    updateEquipment: true,
  }),
};

export default equipmentAxis;
